import { INTERCOM_TRIGGER } from '@sparklayer-io/spark-dash-core/constants/intercom';
import { isShopify, useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { shopifyThemeSetupUrl } from '@sparklayer-io/spark-dash-pages';
import { useHandlers } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { adminBookCall, frame29 } from '@sparklayer-io/spark-dash-ui/assets';
import { MediaCard } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const COMPONENT = 'features:home.components.onboarding_actions' satisfies I18nPrefix;

export function OnboardingActions() {
  const env = useEnv();
  const { navigationHandler } = useHandlers();

  // On Shopify, "Get started" deep-links straight to the app's own theme-setup screen instead of opening Intercom.
  // This never renders on Shopify, but cheap to keep.
  const themeSetupUrl = isShopify(env.connected_platform)
    ? shopifyThemeSetupUrl(env.store_id)
    : null;

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
      <MediaCard
        headingLevel="h3"
        imgSrc={frame29}
        title={t(`${COMPONENT}.install.title`)}
        description={t(`${COMPONENT}.install.description`)}
        // Intercom watches for this class and opens the "install for me" workflow itself.
        buttonClassName={themeSetupUrl ? undefined : INTERCOM_TRIGGER.install}
        action={{
          icon: 'checkCircle',
          content: t(`${COMPONENT}.install.action`),
          onClick: themeSetupUrl
            ? () => navigationHandler.navigate(themeSetupUrl, { absolute: true, newTab: true })
            : () => {},
        }}
      />
      <MediaCard
        headingLevel="h3"
        imgSrc={adminBookCall}
        title={t(`${COMPONENT}.book_call.title`)}
        description={t(`${COMPONENT}.book_call.description`)}
        // Intercom watches for this class and opens the "book a call" workflow itself.
        buttonClassName={INTERCOM_TRIGGER.onboarding}
        action={{ icon: 'chat', content: t(`${COMPONENT}.book_call.action`), onClick: () => {} }}
      />
    </div>
  );
}
